import React from 'react'
import styled from 'styled-components'
import ContentModal from '../ContentModal'
import AccidentModalInsurance from './components/AccidentModalInsurance'
import AccidentModalQuotes from './components/AccidentModalQuotes'
import AccidentModalRepairs from './components/AccidentModalRepairs'
import { ContentModalCtrl } from '../ContentModalSection'
import PhoneNumberLink from '../PhoneNumberLink'
import LinkRounded from '../LinkRounded'

const LinkWrap = styled.div`
  text-align: center;
  display: block;
  width: 100%;
  margin-bottom: 60px;
  margin-top: -30px;
  position: relative;
  z-index: 2;
`

const AccidentModal = (props) => {
  const { show, onClose } = props
  return show ? (
    <ContentModal
      title="Had an accident?"
      subtitle={<PhoneNumberLink number="+44 330 178 3477" />}
      summary="Our 24-hour accident helpline is always open to assist you—whether at home or abroad. We’ll handle everything from insurance claims to repair bookings, ensuring your vehicle is seamlessly restored by the expert team at Citygate Bodyshop."
      slim
      open
      onClose={onClose}
    >
      <LinkWrap>
        <LinkRounded thin shadow mt={10} href={`/bodyshop`}>
          Citygate Bodyshop
        </LinkRounded>
      </LinkWrap>

      <ContentModalCtrl
        sections={[
          {
            default: `We’ll talk to the insurance companies`,
            active: `We’ll talk to the insurance companies`,
            content: <AccidentModalInsurance />,
            info: true
          },
          {
            default: `We’ll get the quotes`,
            active: `We’ll get the quotes`,
            content: <AccidentModalQuotes />,
            info: true
          },
          {
            default: `We’ll book your car in for repairs`,
            active: `We’ll book your car in for repairs`,
            content: <AccidentModalRepairs />,
            info: true
          }
        ]}
      />
    </ContentModal>
  ) : null
}

export default AccidentModal
